// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ITariffIdentificator {
  tariffId: number;
  tariffGridType: ETariffGridType;
  days?: number;
  periodType: EPeriodType;
  serviceTypes?: EServiceTypes[];
  packageId: number;
  diffPriceId?: number;
  diffPriceIterationId?: string;
  diffPriceGranuleGuid?: string;
}
export enum ETariffGridType {
  /** Тарифная сетка на основе пакетов и таблицы Tariff **/
  'PackageTariff' = 'PackageTariff',
  /**
   * Покупка по слоту из пакета размещений. (Размещение объявления по пакету).
   * TariffAction для таких теперь создается, но не списывается
   */
  'ServicePackageGroup' = 'ServicePackageGroup',
  /** Покупка пакета размещений **/
  'ServicePackage' = 'ServicePackage',
  /** Произвольное ценообразование **/
  'DynamicPricing' = 'DynamicPricing',
}
export enum EPeriodType {
  /** Ограниченая по дням публикация  - подневная тарификация **/
  'DailyLimited' = 'DailyLimited',
  /** Бессрочная публикация - подневная тарификация **/
  'DailyTermless' = 'DailyTermless',
  /** Тарификация за весь период **/
  'Periodical' = 'Periodical',
}
export enum EServiceTypes {
  /** Платная публикация **/
  'DebitObject' = 'DebitObject',
  /** Премиум публикация **/
  'PremiumObject' = 'PremiumObject',
  /** Тор 3 **/
  'Top3' = 'Top3',
  /** Выделение цветом **/
  'Highlight' = 'Highlight',
  /** Подмена номера, Calltracking, оно же "защита номера" **/
  'Calltracking' = 'calltracking',
  /** Бесплатная публикация **/
  'FreeObject' = 'FreeObject',
  /** Выгрузка объявлений через XML **/
  'XmlImport' = 'XmlImport',
  /** Абонентская плата за пакет **/
  'SubscriptionForPackage' = 'SubscriptionForPackage',
  /** Признак статуса ПРО **/
  'StatusPro' = 'StatusPro',
  /** Массовый пакет **/
  'ServicePackageActivation' = 'ServicePackageActivation',
  /** Штрафное списание **/
  'Penalty' = 'Penalty',
  /** Отмена платежа **/
  'OrderCancellation' = 'OrderCancellation',
  /** перенос платежа **/
  'OrderTransfer' = 'OrderTransfer',
  /** Произвольное списание **/
  'TechSpend' = 'TechSpend',
  /** Перенос произвольной суммы **/
  'TechTransfer' = 'TechTransfer',
  /** Списание истекшего бонусного пополнения **/
  'BonusPaymentExpiration' = 'BonusPaymentExpiration',
  /** Списание за аукцион **/
  'Auction' = 'auction',
  /** Списание за заявку на спрос **/
  'Demand' = 'demand',
  /** Списание за пакет заявок на спрос **/
  'DemandPackage' = 'demandPackage',
  /** Коллтрекинг по модели CPL **/
  'CplCalltracking' = 'cplCalltracking',
  /** Динамическая услуга **/
  'Dynamic' = 'dynamic',
}
